import { render, staticRenderFns } from "./StandardSmallSolidButton.vue?vue&type=template&id=ed851810&scoped=true"
import script from "./StandardSmallSolidButton.vue?vue&type=script&lang=js"
export * from "./StandardSmallSolidButton.vue?vue&type=script&lang=js"
import style0 from "./StandardSmallSolidButton.vue?vue&type=style&index=0&id=ed851810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed851810",
  null
  
)

export default component.exports